import { Component, OnInit } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { formatDuration } from 'src/app/utils/utils.common';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';


@Component({
  selector: 'app-otp-list',
  templateUrl: './otp-list.component.html',
  styleUrls: ['./otp-list.component.css']
})
export class OtpListComponent implements OnInit {
  dataList = [];
  filterdataList = [];
  search: any;
  timeZone;
  user;
  drivers;
  preSpaceTypes = {};
  preLevelOfServices = {};
  levelOfServiceList = [];
  spaceTypeList = [];
  todayDate: any;
  preDrivers = {};
  tripDetailModalObj;
  completedTripModalObj;
  isEnabledOneHourException = true;

  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private driverService: DriversService,
    private csvService: CsvService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getUser();
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment.tz(this.timeZone),
          this.getDrivers();
          this.getTrips();
          if (this.user.hasOwnProperty('hideOneHourException') && this.user.hideOneHourException) {
            this.isEnabledOneHourException = false;
          }
        }
      });
  }

  getTrips() {
    this.clearTrips();
    const object = {
      date: [this.todayDate.startOf("day").toISOString(),this.todayDate.endOf("day").toISOString()],
    };
    this.assignTripService
      .getKpiScore(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList = data;
            this.filterdataList = data;
            this.filterdataList.map((item) => {
              item.driver = this.preDrivers[item.driver] || {};
            });
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }


  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }


  ngOnDestroy(): void {
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  onDateChange(event) {
    this.todayDate = event;
    this.getTrips();
  }

  getDrivers() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDrivers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  clearTrips() {
    this.filterdataList = [];
    this.dataList = [];
  }

  downloadCsvReport() {
    const data = {
      trips: this.dataList,
      preDrivers: this.preDrivers,
      preLevelOfServices: this.preLevelOfServices,
      preSpaceTypes: this.preSpaceTypes,
      timeZone: this.timeZone,
      searchDate: this.todayDate,
      isEnabledOneHourException: this.isEnabledOneHourException
    }
    this.csvService.generateOtpReport(data);
  }

  formatMinutes(durationValue: any) {
    return formatDuration(durationValue);
  }
}
